import { render, staticRenderFns } from "./UserViewSidebarAdd.vue?vue&type=template&id=93ed8fac&scoped=true&"
import script from "./UserViewSidebarAdd.vue?vue&type=script&lang=js&"
export * from "./UserViewSidebarAdd.vue?vue&type=script&lang=js&"
import style0 from "./UserViewSidebarAdd.vue?vue&type=style&index=0&id=93ed8fac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93ed8fac",
  null
  
)

export default component.exports